import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { CUSTOM_MASK } from '@helpers/custom-validator';
import { IErrorForm } from '@shared/form-wrapper/interfaces';

@Component({
  selector: 'lcl-route-warning',
  templateUrl: './lcl-route-warning.component.html',
  styleUrls: ['./lcl-route-warning.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LclRouteWarningComponent {
  @Input() public customerNotesFc: UntypedFormControl;
  @Input() public emailFc: UntypedFormControl;
  @Input() public nameFc: UntypedFormControl;
  @Input() public passwordFc: UntypedFormControl;
  @Input() public isWithForm: boolean;
  @Input() public isWithEmailAndName: boolean;
  @Input() public isShowUserExists: boolean;
  @Input() public isButtonDisabled: boolean;
  @Input() public isMobile: boolean;
  @Input() public isExternal: boolean;
  @Input() public errors: IErrorForm;
  @Output() public close: EventEmitter<void> = new EventEmitter<void>();
  @Output() public notesSubmit: EventEmitter<void> = new EventEmitter<void>();

  public CUSTOM_MASK: typeof CUSTOM_MASK = CUSTOM_MASK;

  constructor() {}
}
